module.exports = __webpack_public_path__ + "img/Blumenwiese-1216.06bb28d5.jpg";